import { animate, style, transition, trigger } from '@angular/animations';

//sync with dashboard.styles.css
const colours = {
  dashboardBackgroundColour: '#00162e',
  dashboardContentPaneBackgroundColour: '#1f3247',
};
const duration = 600; //sync with dashboard.styles.scss
const t = 0.7;
export const dashboardStyles = {
  colours,
  transitionDuration: duration,
  shortTransitionDuration: duration * (1 - t),
  shortTransitionT: t,
};
export const animations = [
  trigger('collapseExpand', [
    transition(':enter', [
      style({ height: '0', opacity: 0 }),
      animate('600ms ease-in-out', style({ height: '*', opacity: 1 })),
    ]),
    transition(':leave', [animate('600ms ease-in-out', style({ height: '0', opacity: 0 }))]),
  ]),
  trigger('collapseExpandHorizontal', [
    transition(':enter', [
      style({ flex: '1 1 0', opacity: 0 }),
      animate('600ms ease-in-out', style({ flex: '1 1 32rem', opacity: 1 })),
    ]),
    transition(':leave', [animate('600ms ease-in-out', style({ flex: '1 1 0', opacity: 0 }))]),
  ]),
];
